// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__PQF3C","itemTitle":"ClientEmergencyInfo_itemTitle__LoVvt","itemText":"ClientEmergencyInfo_itemText__1ag58"};